"use client";

import { useEffect } from 'react';
import { useDispatch } from '@/store/hooks';
import { loadSavedSettings } from '@/store/customizer/CustomizerSlice';
import { isBrowser } from '@/utils/localStorage';

/**
 * Componente para inicializar as configurações persistentes do customizer
 * Deve ser usado no início da aplicação para carregar as configurações salvas
 */
const CustomizerInitializer = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Carregar configurações salvas apenas no cliente
    if (isBrowser()) {
      dispatch(loadSavedSettings());
    }
  }, [dispatch]);

  return null; // Este componente não renderiza nada
};

export default CustomizerInitializer;